import domReady from "@wordpress/dom-ready";
import YouTubePlayer from "youtube-player";
import VimeoPlayer from "@vimeo/player";

window.player = null;
window.videoType = "";
let currentVideo = null;

domReady(() => {
	const modal = document.querySelector(".modal-wrapper.modal-wrapper-video");
	// console.log({ modal });
	if (modal) {
		// VIDEO
		const openVideoModalBtns = document.querySelectorAll(".open-video-modal");
		// console.log({ openVideoModalBtns });
		openVideoModalBtns?.forEach((button) => {
			button.addEventListener("click", () => {
				currentVideo = button;
				window.videoType = button.getAttribute("data-video-type");
				// console.log({ window.videoType });

				if (!button.classList.contains("video-loaded")) {
					openVideoModalBtns?.forEach((item) =>
						item.classList.remove("video-loaded")
					);

					if (window.videoType === "url" || window.videoType === "file") {
						const video = button.getAttribute("data-video");
						modal.querySelector(
							".modal-content-video"
						).innerHTML = `<video controls playsinline><source src="${video}" type="video/mp4"></video>`;
						window.player = modal.querySelector(".modal-content-video video");
					} else {
						const videoId = button.getAttribute("data-video-id");
						modal.querySelector(
							".modal-content-video"
						).innerHTML = `<div class="${window.videoType}-player" id="video-player-${videoId}"></div>`;
						if (window.videoType === "youtube") {
							loadYouTubeIframeAPI(`video-player-${videoId}`, videoId);
						} else if (videoType === "vimeo") {
							loadVimeoIframeAPI(`video-player-${videoId}`, videoId);
						}
					}

					button.classList.add("video-loaded");
				}

				document.body.classList.add("no-scroll");
				jQuery(modal).fadeIn(500, "easeInOutCirc", () => {
					modal.classList.add("show");
					setTimeout(() => playVideo(videoType), 500);
				});
			});
		});
	}
});

// YOUTUBE
export const loadYouTubeIframeAPI = (playerID, videoID) => {
	// console.log("youtube api", playerID, videoID);
	window.player = YouTubePlayer(playerID, {
		width: "1400",
		height: "788",
		videoId: videoID,
	});
	// player.loadVideoById(videoID);
	window.player.playVideo();
};

// VIMEO
export const loadVimeoIframeAPI = (playerID, videoID) => {
	window.player = new VimeoPlayer(playerID, {
		id: videoID,
		width: 1400,
		height: "auto",
		maxHeight: "100%",
	});
	// player.setVolume(0);
	window.player.play();
};

export const playVideo = (host) => {
	if (host === "youtube") {
		window.player.playVideo();
	} else {
		window.player.play();
	}
};

export const stopVideo = (host) => {
	if (host === "youtube") {
		window.player.stopVideo();
	} else {
		window.player.stop();
	}
};

export const pauseVideo = (host) => {
	if (host === "youtube") {
		window.player.pauseVideo();
	} else {
		window.player.pause();
	}
};
